<template>
    <div class="mb-16">
        <select-dropdown
            v-model="filter.user"
            :searchable="true"
            :auto-translate="false"
            :loading="fetching"
            :options="users"
            :placeholder="$t('form.dropdown.placeholder').toString()"
            remove-icon
        >
        </select-dropdown>
    </div>
</template>

<script>
import SelectDropdown from "../forms/SelectDropdown";
import {mapState} from "pinia";
import {useRepo} from "pinia-orm";
import {useMainStore} from "../../state/store";
import User from "../../models/User";

export default {
    name: 'FilterJobResponsibleUser',
    components: {
        SelectDropdown,
    },
    data: function() {
        return {
            fetching: true
        }
    },
    props: {
        filter: {type: Object},
    },
    computed: {
        ...mapState(useMainStore, ['locale']),
        users() {
            const users = useRepo(User).all().map(user => ({
                value: user.id,
                label: user.name
            })).sort((a, b) => a.label.localeCompare(b.label));

            users.unshift({
                value: null,
                label: this.$t('jobs.index_filters.users')
            });
            return users;
        },
    },
    mounted() {
        User.fetchUsers().then(this.fetching = false)
    }
}
</script>
